import AppButton from 'src/components/AppButton';
import RangeCalendar from 'src/components/RangeCalendar';
import Modal from 'src/components/Modal';
import ModalDialog from 'src/components/ModalDialog';
import React, { useState, useCallback } from 'react';
import classes from './OverrideModal.module.scss';
import { getDateFromDateTimeString } from 'src/utils/getTimeFromString';
import Calendar from '../Calendar';

export const OverrideModal = (props) => {
    const [selectedDate, setSelectedDate] = useState();

    const handleChangeSelectedDate = useCallback((dates, times) => {
        setSelectedDate({
          start: getDateFromDateTimeString(dates.start, times[0]),
          end: getDateFromDateTimeString(dates.end, times[1])
        });
    }, []);

    const handleConfirm = () => { 
      props.onChange(
          {
              id: '',
              start: selectedDate.start,
              end: selectedDate.end,
          }
      );
      props.onClose();
    };

    return (
        <Modal isShow={props.isOpen} onClose={props.onClose}>
          <ModalDialog
            style={{
                maxHeight: '90vh',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}
          >
            {props.isEdit === false && (
                <h2 className={classes.title}>Select the date(s) you want to assign specific hours</h2>
            )}
            {props.isRange ? 
              <RangeCalendar
                onChangeSelectedDate={handleChangeSelectedDate}
                data={props.data}
                isViewOnly={props.isEdit}
                startWeekday={'Mo'}
                disablePast={true}
                highlightToday={false}
                isHighlightSlotDate={true}
              /> :
              <Calendar 
                onChangeSelectedDate={handleChangeSelectedDate}
                selectedDate={props.data?.startTime && props.data.startTime}
                isViewOnly={props.isEdit}
                startWeekday={'Mo'}
                multipleSelection={false}
                disablePast={true}
                highlightToday={false}
                isHighlightSlotDate={true}
                isTimeShow={false}
              />
            }

            <div className={classes.overrideModalButtons}>
                <button onClick={props.onClose}>Cancel</button>
                <AppButton
                    onClick={handleConfirm}
                    text='Apply'
                />
            </div>
          </ModalDialog>
        </Modal>
    );
};
